export default __webpack_public_path__ + "static/media/LIGHT_CLAIM_ILLUSTRATION.da1bdbd4.svg";